<template>
    <div class="" data-cy="container_survey_question_list">
        <div v-if="questionList.length > 0" class="w-full">
            <QuestionItem 
                data-cy="component_survey_question_item"
                v-if="questionList[step - 1]" 
                :question="questionList[step - 1]" 
                :currentStep="step"
                :totalSteps="questionList.length"
                :selectedRating="selectedRatings[step - 1]"
                @rate="handleRate"
                @prev="prevStep"
                @next="nextStep"
            />
        </div>
    </div>
</template>
<script>
// component
import QuestionItem from './QuestionItem.vue';
export default {
    name: "QuestionList",
    components: {
        QuestionItem
    },
    props: {
        questionList: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            step: 1,
            selectedRatings: Array(this.questionList?.length || 0).fill(null),
            quizScores: []
        };
    },
    watch: {
        questionList: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.length) {
                    this.selectedRatings = Array(newVal.length).fill(null);
                    // Initialize quizScores array
                    this.quizScores = newVal.map((question, index) => ({
                        QuizType: question.QuizType || `Q${index + 1}`,
                        Score: null
                    }));
                }
            }
        }
    },
    methods: {
        handleRate(rating) {
            // Update selectedRatings array
            this.selectedRatings.splice(this.step - 1, 1, rating);
            
            // Update quizScores array
            if (this.quizScores[this.step - 1]) {
                this.quizScores[this.step - 1].Score = rating;
            }
            
            console.log('Updated quizScores:', this.quizScores);
        },
        getQuizScores() {
            // Return only completed scores (non-null)
            return this.quizScores.filter(quiz => quiz.Score !== null);
        },
        getAllQuizScores() {
            // Return all quiz scores (including null scores)
            return this.quizScores;
        },
        nextStep() {
            if (this.step < this.questionList.length) {
                this.step++;
            } else if (this.step === this.questionList.length) {
                this.$emit('submitQuizScores', this.quizScores);
            }
        },
        prevStep() {
            if (this.step === 1) {
                this.$emit('setStep', 'welcome');
                return;
            }
            if (this.step > 1) {
                this.step--;
            }
        }
    }
}
</script>
<style scoped>
</style>